import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

function CashoutTab() {
  const [amount, setAmount] = useState("");
  const [withdrawalMethod, setWithdrawalMethod] = useState("");
  const [paymentDetails, setPaymentDetails] = useState("");
  const [showModal, setShowModal] = useState(false);

  const handleCashout = (e) => {
    e.preventDefault();
    console.log("Cashout:", { amount, withdrawalMethod, paymentDetails });

    // Show success modal
    setShowModal(true);
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      className="bg-white shadow overflow-hidden sm:rounded-lg p-6"
    >
      <h3 className="text-lg leading-6 font-medium text-gray-900">Cashout</h3>
      <p className="mt-1 max-w-2xl text-sm text-gray-500">
        Withdraw funds from your account
      </p>

      <form onSubmit={handleCashout} className="mt-4">
        <div className="space-y-4">
          <div>
            <label
              htmlFor="amount"
              className="block text-sm font-medium text-gray-700"
            >
              Amount
            </label>
            <div className="relative mt-1 rounded-md shadow-sm">
              <span className="absolute inset-y-0 left-0 pl-3 flex items-center text-gray-500">
                $
              </span>
              <input
                type="text"
                id="amount"
                className="focus:ring-indigo-500 focus:border-indigo-500 block w-full pl-7 pr-12 py-2 sm:text-sm border-gray-300 rounded-md"
                placeholder="0.00"
                value={amount}
                onChange={(e) => setAmount(e.target.value)}
              />
            </div>
          </div>

          <div>
            <label
              htmlFor="withdrawalMethod"
              className="block text-sm font-medium text-gray-700"
            >
              Withdrawal Method
            </label>
            <select
              id="withdrawalMethod"
              className="mt-1 block w-full py-2 border-gray-300 focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md"
              value={withdrawalMethod}
              onChange={(e) => setWithdrawalMethod(e.target.value)}
            >
              <option value="">Select withdrawal method</option>
              <option value="bank">Bank Transfer</option>
              <option value="paypal">PayPal</option>
              <option value="crypto">Cryptocurrency</option>
            </select>
          </div>

          {withdrawalMethod && (
            <motion.div
              initial={{ opacity: 0, x: -20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.4 }}
            >
              <label
                htmlFor="paymentDetails"
                className="block text-sm font-medium text-gray-700"
              >
                {withdrawalMethod === "bank"
                  ? "Bank Account Number"
                  : withdrawalMethod === "paypal"
                  ? "PayPal Email"
                  : "Crypto Wallet Address"}
              </label>
              <input
                type="text"
                id="paymentDetails"
                className="mt-1 block w-full py-2 border-gray-300 focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md"
                placeholder={
                  withdrawalMethod === "bank"
                    ? "Enter bank account number"
                    : withdrawalMethod === "paypal"
                    ? "Enter PayPal email"
                    : "Enter crypto wallet address"
                }
                value={paymentDetails}
                onChange={(e) => setPaymentDetails(e.target.value)}
              />
            </motion.div>
          )}
        </div>

        <motion.button
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          type="submit"
          className="w-full mt-6 py-2 px-4 text-white bg-indigo-600 hover:bg-indigo-700 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500"
        >
          Withdraw Funds
        </motion.button>
      </form>

      {/* Success Modal */}
      <AnimatePresence>
        {showModal && (
          <motion.div
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.8 }}
            transition={{ duration: 0.3 }}
            className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50"
          >
            <div className="bg-white p-6 rounded-lg shadow-lg">
              <h2 className="text-lg font-bold">Success!</h2>
              <p className="mt-2 text-gray-600">
                You have successfully withdrawn your funds.
              </p>
              <motion.button
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                className="mt-4 w-full py-2 px-4 bg-indigo-600 text-white rounded-md hover:bg-indigo-700"
                onClick={() => setShowModal(false)}
              >
                Close
              </motion.button>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.div>
  );
}

export default CashoutTab;
